import NavBar from "../common/NavBar";
import NavBarFooter from "../common/NavBarFooter";
import QuizAPI from "../components/quiz_api";

const ButterFlyQuizz = () => {
    return (
        <div className="outline">
            <NavBar />
                <h1>Science and Nature</h1>
                <p>Who doesn't like the most beautiful insect that literally transforms itself during its life.</p>
                <hr />
                {/* <QuizzMaster endpoint="butterflies" /> */}
                <QuizAPI category="17" />
            <NavBarFooter />
        </div>
    )
}

export default ButterFlyQuizz;